import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createContext, useContext } from 'react';
import { FieldNames } from '@atlassian/commerce-credit-card-base';
import { useOnCardNumberChangeBrandValidation } from '../brand-validation';
import { useHAMSTokenServiceHookWithUrl } from '../use-hams-token-service';
import { PAYMENT_METHOD_TOKEN_URL, STRIPE_KEY_URL } from './constants';
var createIntentSecretURLContext = /*#__PURE__*/createContext(undefined);
export var CreateIntentSecretURLProvider = createIntentSecretURLContext.Provider;
export var useIntentSecretURL = function useIntentSecretURL() {
  var url = useContext(createIntentSecretURLContext);
  return url !== undefined ? url : PAYMENT_METHOD_TOKEN_URL;
};
export var useHAMSServiceWithUrl = function useHAMSServiceWithUrl() {
  var stripeKeyUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STRIPE_KEY_URL;
  var token = useHAMSTokenServiceHookWithUrl(stripeKeyUrl);
  var onCardNumberChangeBrandValidation = useOnCardNumberChangeBrandValidation();
  return {
    token: token,
    fieldConfigs: _defineProperty({}, FieldNames.NUMBER, {
      onChange: onCardNumberChangeBrandValidation
    })
  };
};